import { Flex, Heading, useTheme } from "@aws-amplify/ui-react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ConfirmResetPasswordHeader = () => {
  const { tokens } = useTheme();
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Heading
        level={3}
        padding={`${tokens.space.xl} ${tokens.space.xl} 0`}
        paddingLeft={0}
        fontWeight={700}
        fontSize={"32px"}
      >
        {t("Reset Password")}
      </Heading>
      <Typography>{t("Enter the Code sent to your email below.")}</Typography>
    </Flex>
  );
};
